module.exports = __webpack_public_path__ + "34bc775d/img/note-list-icon.961c1485.svg";